import { createSelector } from 'reselect';

import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';

const COMMENT_COUNT_THRESHOLD = 4;

const SETTING_STAFF = 'staff';
const SETTING_ALL = 'all';

// "Activated for staff" covers library staff, library admins and BC admin accounts
// (CORE-79268) — deliberately not the user's `staff` flag, which is LIBRARY_STAFF only.
const STAFF_ROLES = ['LIBRARY_STAFF', 'LIBRARY_ADMIN', 'SYS_ADMIN'];

export const selectCommentSummary = state => state.getIn(['bibs', 'ugc', 'commentSummary'], null);

const selectCommentSummarySetting = createSelector([selectCurrentLibrary], library =>
  library.get('commentSummary', null)
);

export const selectIsCommentSummaryPermitted = createSelector(
  [selectCommentSummarySetting, selectCurrentUser],
  (setting, currentUser) => {
    if (setting === SETTING_ALL) {
      return true;
    }
    if (setting === SETTING_STAFF) {
      const roles = currentUser?.get('roles');
      return Boolean(roles?.some(role => STAFF_ROLES.includes(role)));
    }
    return false;
  }
);

const selectTotalCommentCount = state =>
  state.getIn(['bibs', 'ugc', 'communityComments', 'pagination', 'count'], 0) +
  state.getIn(['bibs', 'ugc', 'staffComments', 'pagination', 'count'], 0);

export const selectIsCommentSummaryEligible = createSelector(
  [selectIsCommentSummaryPermitted, selectTotalCommentCount, selectCommentSummary],
  (isPermitted, commentCount, commentSummary) => {
    // The summary text itself must be non-empty — a payload carrying a blank one would otherwise
    // render the panel's heading, disclaimer, and actions wrapped around nothing.
    const summaryText = commentSummary?.get('summary');

    return isPermitted && commentCount >= COMMENT_COUNT_THRESHOLD && Boolean(summaryText?.trim());
  }
);
